import React, {useState, useEffect} from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import {t} from 'react-switch-lang';
import './historyModal.scss';
import {format, parseISO} from 'date-fns';
import Modal from 'reactstrap/lib/Modal';
import {getAllAppliedMeasureResults} from '../../../services/measuresService/measuresApi';

function ShowHistoryModal({data, open, isOpen}) {
  const [appliedMeasures, setAppliedMeasures] = useState([]);

  useEffect(() => {
    getAllAppliedMeasureResults(data)
      .then((res) => {
        setAppliedMeasures(res.data);
      })
      .catch((err) => {
        // console.log(err, 'error');
      });
  }, [data]);

  const toggleShowModal = (e) => {
    e && e.preventDefault();
    isOpen(!open);
  };

  return (
    <>
      <Modal isOpen={open} className="modal-md">
        <div className="close-img">
          <img
            src="/images/exclusion.svg"
            alt="Exclusion"
            onClick={(e) => toggleShowModal(e)}
            style={{cursor: 'pointer'}}
          />
        </div>
        <div className="modal-header history-header">
          {t('mitigation-measures.history-modal.title')}
        </div>
        <div className="modal-body">
          {appliedMeasures && appliedMeasures.length > 0 ? (
            appliedMeasures.map((item, idx) => {
              return (
                <div className="main-text" key={idx}>
                  <p className="small-date-time">
                    <span className="date">
                      {format(parseISO(item.dateCreated), 'dd.MM.yyyy.')}
                    </span>
                    <span className="time">
                      {format(parseISO(item.dateCreated), 'HH:mm')}
                    </span>
                  </p>
                  <p className="main-text">{item.name}</p>
                </div>
              );
            })
          ) : (
            <div className="no-measures pb-3">
              {t('common.noResultsOfMeasure')}{' '}
            </div>
          )}
        </div>
        <div className="modal-footer history-footer">
          <button
            onClick={(e) => toggleShowModal(e)}
            type="button"
            className="primary-btn"
          >
            {t('buttons.okBtn')}
          </button>
        </div>
      </Modal>
    </>
  );
}

export default ShowHistoryModal;
